import { Directive, DirectiveBinding } from 'vue';
import { MixpanelViewProperties } from 'types/analytics';
import router from '@router/index';
import { useMixpanel } from '@utils/composables/use-mixpanel';

const OBSERVER = '_SCROLLED_INTO_VIEW_OBSERVER';

interface HTMLElementWithObserver extends HTMLElement {
	[OBSERVER]?: IntersectionObserver;
}

export const ScrolledIntoView: Directive = {
	mounted: function (el: HTMLElement, binding: DirectiveBinding<Partial<MixpanelViewProperties>>) {
		const element = el as HTMLElementWithObserver;
		const threshold = element.offsetHeight > window.innerHeight ? 0.1 : 0.9;

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const { trackMixpanelView } = useMixpanel(router.currentRoute.value);
						trackMixpanelView('Element', binding.value);
						observer.disconnect();
					}
				});
			},
			{ threshold }
		);

		element[OBSERVER] = observer;
		observer.observe(element);
	},
	unmounted: function (el: HTMLElement) {
		const element = el as HTMLElementWithObserver;
		if (element[OBSERVER]) {
			element[OBSERVER].disconnect();
		}
	}
};

export default ScrolledIntoView;
